export const STATE_NAME = 'navBar';
